define([
	"csi/def/ActionFactory",
	"./_StateAction"
], function(ActionFactory,_StateAction) {

	return ActionFactory.declare("MakePending2", _StateAction, {
		m_tag: "MakePending2"
	});
});